import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment"

@Injectable({
    providedIn: "root"
})
export class ApiService {
    private baseRoute: string;

    constructor(private httpClient: HttpClient) {
        this.baseRoute = environment.apiRoot + "api/";
    }

    private buildHeaders(): HttpHeaders {
        if (localStorage.access_token) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + localStorage.access_token
            });
        }
        return new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    private buildParams(): HttpParams {
        return new HttpParams();
    }

    get route() {
      return this.baseRoute;
    }

	get<T>(route: string): Observable<T> {
        return this.httpClient.get<T>(`${this.baseRoute}${route}`, {
            headers: this.buildHeaders(),
            params: this.buildParams()
        });
    }

    post<T>(route: string, payload: any = null): Observable<T> {
        return this.httpClient.post<T>(`${this.baseRoute}${route}`, payload, {
            headers: this.buildHeaders(),
            params: this.buildParams()
        });
    }

    postText(route: string, payload: any = null): Observable<string> {
        return this.httpClient.post(`${this.baseRoute}${route}`, payload, {
            headers: this.buildHeaders(),
            params: this.buildParams(),
            responseType: 'text'
        });
    }

    posth<T>(route: string, payload: any = null, headers: any): Observable<T> {
        return this.httpClient.post<T>(`${route}`, payload, {
            headers: headers
        });
    }

    postwh<T>(route: string, payload: any, headers: HttpHeaders): Observable<T> {
        return this.httpClient.post<T>(`${this.baseRoute}${route}`, payload, {
            headers: headers
        });
    }

    put<T>(route: string, payload: any = null): Observable<T> {
        return this.httpClient.put<T>(`${this.baseRoute}${route}`, payload, {
            headers: this.buildHeaders(),
            params: this.buildParams()
        });
    }

    delete<T>(route: string): Observable<T> {
        return this.httpClient.delete<T>(`${this.baseRoute}${route}`, {
            headers: this.buildHeaders(),
            params: this.buildParams()
        });
    }

    getFile(route: string): Observable<Blob> {
        return this.httpClient.get(`${this.baseRoute}${route}`, {
            headers: this.buildHeaders(),
            params: this.buildParams(),
            responseType: 'blob'
        });
    }

}
